export const IMAGES_RESOLUTIONS = {
  is: 50,
  im: 80,
  il: 100,
  xxs: 200,
  xs: 400,
  sm: 800,
  md: 1000,
  lg: 1200,
};

export const IMAGES_ALL_RESOLUTIONS = Object.values(IMAGES_RESOLUTIONS);
export const IMAGES_ICONS_RESOLUTIONS = Object.values(IMAGES_RESOLUTIONS).filter((r) => r <= IMAGES_RESOLUTIONS.xs);
export const IMAGES_SCREENS_RESOLUTIONS = Object.values(IMAGES_RESOLUTIONS).filter((r) => r >= IMAGES_RESOLUTIONS.xxs);

export const IMAGES_RESOLUTIONS_KEYS = Object.keys(IMAGES_RESOLUTIONS);

export interface IImageConfig {
  typeDescription: string;
  aspectRatio: { w: number; h: number };
  defaultResolution: number;
  resolutions: number[];
  pathAccepted: RegExp[];
}
